import { Component } from '@angular/core';
import { PwaService } from './pwa.service';

/** Kis sáv a tartalom alján: „új verzió érhető el" és „telepítsd az appot". */
@Component({
  selector: 'app-pwa-banner',
  templateUrl: './pwa-banner.component.html',
  styleUrl: './pwa-banner.component.scss',
})
export class PwaBannerComponent {
  updating = false;

  constructor(public pwa: PwaService) {}

  update(): void {
    this.updating = true;
    this.pwa.applyUpdate();
  }
}
